import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Form, Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { LinkSecondaryButton, AddContentButton } from '../../uiComponents/input/Buttons';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { Loading } from '../../uiComponents/Loading';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { EditorStateModel } from '../../models/EditorStateModel';
import DraftHelper from '../../infrastructure/DraftHelper';
import { EditorState } from 'draft-js';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';
import { Redirect } from 'react-router-dom';
import { Vejledning } from '../../models/Vejledning';
import { VejledningAfsnit } from '../../models/VejledningAfsnit';
import VejledningAfsnitEdit from './VejledningAfsnitEdit';
import { RouteComponentProps } from 'react-router';
import { getVejledningTitle } from './VejledningTitle';
import { Section } from '../../uiComponents/layout/Section';

export interface VejledningContainerProps extends RouteComponentProps<any> {

}

interface VejledningContainerState {
    vejledning?: Vejledning;
    editorStates: EditorStateModel[];
    validationResult: ValidationResult;
    isSaved: boolean;
    isSubmitting: boolean;
}

export default class VejledningContainer extends React.Component<VejledningContainerProps, VejledningContainerState> {
    constructor(props: VejledningContainerProps) {
        super(props);
        this.state = {
            vejledning: undefined,
            editorStates: new Array(),
            validationResult: new ValidationResult(),
            isSaved: false,
            isSubmitting: false,
        };

        this.onAfsnitRemoved = this.onAfsnitRemoved.bind(this);
    }

    componentDidMount() {
        this.getVejledning(this.props.match.params.type);
    }

    getVejledning(type: string) {
        let self = this;
        let apicaller = createApiCaller();
        apicaller.getVejledning(type)
            .then((response) => {
                this.setState({ vejledning: response, editorStates: self.getEditorStates(response.afsnit) });
            });
    }

    componentWillReceiveProps(newProps: VejledningContainerProps) {
        this.getVejledning(newProps.match.params.type);
    }

    getEditorStates = (afsnit: VejledningAfsnit[]) => {
        return afsnit.map((a, i) => {
            let editorstateModel = new EditorStateModel();
            editorstateModel.editorState = DraftHelper.getContentAsEditorState(a.editorStateJson);
            editorstateModel.index = i;
            return editorstateModel;
        });
    }

    onVejledningSave = () => {
        this.setState({ isSubmitting: true });

        if (this.state.vejledning !== undefined) {
            let apicaller = createApiCaller();
            let type = this.props.match.params.type;
            let vejledning = this.state.vejledning;
            vejledning.type = type;
            apicaller.createVejledning(this.state.vejledning)
                .then((validationResult: ValidationResult) => {
                    this.setState({ validationResult: validationResult, isSaved: validationResult.isValid ? true : false, isSubmitting: false });
                    if (validationResult.isValid) {
                        NotificationQueue.push(new NotificationData('Ændringerne blev gemt', '', 'success'));
                    }
                });
        }
    }

    onAfsnitRemoved(index: number) {
        const tmpState = this.state;

        if (tmpState.vejledning !== undefined) {
            tmpState.vejledning.afsnit.splice(index, 1);
            this.setState(tmpState);
        }
    }

    onAddAfsnit() {
        let tmpState = this.state;

        if (tmpState.vejledning !== undefined) {
            const afsnit = new VejledningAfsnit();
            afsnit.overskrift = '';
            afsnit.editorStateJson = '';
            tmpState.vejledning.afsnit.push(afsnit);
            const editorStateModel = new EditorStateModel();
            editorStateModel.editorState = DraftHelper.getEmptyEditorState();
            editorStateModel.index = tmpState.editorStates.length;
            tmpState.editorStates.push(editorStateModel);
            this.setState(tmpState);            
        }
    }

    onVejledningChanged = (index: number, fieldName: string, value: any) => {
        let tmpState = this.state;

        if (tmpState.vejledning !== undefined) {
            let afsnit = tmpState.vejledning.afsnit[index];
            if (afsnit !== undefined) {
                afsnit[fieldName] = value;
                this.setState(tmpState);
            }
        }
    }

    onEditorChanged = (index: number, editorState: EditorState): void => {
        if (this.state.vejledning !== undefined) {
            let vejledning = this.state.vejledning;
            let editorStates = this.state.editorStates;
            let editorStateModel = editorStates[index];

            if (editorStateModel !== undefined) {
                editorStateModel.editorState = editorState;
            }

            let afsnit = vejledning.afsnit[index];
            
            if (afsnit !== undefined) {
                afsnit.editorStateJson = DraftHelper.getEditorStateAsJson(editorState);
            }

            this.setState({ editorStates: editorStates, vejledning: vejledning });
        }
    }

    getEditorState = (index: number): EditorStateModel | undefined => {
        return this.state.editorStates[index];
    }

    getAfsnit = () => {
        if (this.state.vejledning !== undefined) {
            const afsnitList = this.state.vejledning.afsnit.map((a, i) => {
                let editorStateModel = this.getEditorState(i);
                if (editorStateModel === undefined) {
                    editorStateModel = new EditorStateModel();
                    editorStateModel.index = i;
                    editorStateModel.editorState = DraftHelper.getEmptyEditorState();
                }

                return (
                    <VejledningAfsnitEdit
                        key={i}
                        afsnit={a}
                        errorMessages={[]}
                        editorState={editorStateModel.editorState}
                        index={i}
                        onEditorChanged={this.onEditorChanged}
                        onAfsnitChanged={this.onVejledningChanged}
                        onAfsnitRemoved={this.onAfsnitRemoved}
                    />
                );
            });
            return afsnitList;
        }

        return undefined;
    }

    render() {
        if (this.state.isSaved === false) {
            return (
                <PageWrapper>
                    <PageTitle title={getVejledningTitle(this.props.match.params.type)} />
                    <Loading isLoading={this.state.vejledning === undefined}>
                        <ContentWrapper>
                            <SectionGroup header={getVejledningTitle(this.props.match.params.type)}>
                                <Form onSubmit={this.onVejledningSave}>
                                    {this.getAfsnit()}
                                    <Section>
                                        <Row>
                                            <Col md={6} mdOffset={3}>
                                                <AddContentButton text={'Tilføj afsnit'} buttonOnClick={() => this.onAddAfsnit()} />
                                            </Col>
                                        </Row>
                                    </Section>
                                    <ButtonSection noBorder={true}>
                                        <LinkSecondaryButton className='spacer' url={'/'} text='Fortryd' />
                                        <SubmitButton isSubmitting={this.state.isSubmitting}>Gem</SubmitButton>
                                    </ButtonSection>
                                </Form>
                            </SectionGroup>
                        </ContentWrapper>
                    </Loading>
                </PageWrapper>
            );
        } else {
            return <Redirect to='/' />;
        }

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Vejledning/VejledningContainer.tsx